@if (value()) {
  <a [href]="url" (click)="onNavigate($event)">{{ value() }}</a>
  <span class="ps-1">
    <a [href]="url" target="_blank">
      <span class="mdi mdi-open-in-new"></span>
    </a>
  </span>
}
